module.exports = __webpack_public_path__ + "static/media/icon-cart-red.cd9d2a3d.svg";